import { QueryKeys } from '@/enums/query-keys'
import { useResidentService } from '@/services/resident'
import {
  GetResidentResponse,
  GetTermsAndConditionsAcceptanceResponse,
  GetActiveTermsOfServiceVersionResponse,
  GetActivePrivacyPolicyVersionResponse,
} from '@/types/resident'
import { Address } from '@/types/address'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

export function useGetResident(
  options?: Omit<
    UseQueryOptions<GetResidentResponse, Error, GetResidentResponse>,
    'queryKey' | 'queryFn'
  >,
) {
  const residentService = useResidentService()

  return useQuery<GetResidentResponse, Error, GetResidentResponse>({
    queryKey: [QueryKeys.getResident],
    queryFn: () => residentService.getResident(),
    ...options,
  })
}

export function useGetTermsAndConditionsAcceptance(
  options?: Omit<
    UseQueryOptions<
      GetTermsAndConditionsAcceptanceResponse,
      Error,
      GetTermsAndConditionsAcceptanceResponse
    >,
    'queryKey' | 'queryFn'
  >,
) {
  const residentService = useResidentService()

  return useQuery<
    GetTermsAndConditionsAcceptanceResponse,
    Error,
    GetTermsAndConditionsAcceptanceResponse
  >({
    queryKey: [QueryKeys.getTermsAndConditionsAcceptance],
    queryFn: () => residentService.getTermsAndConditionsAcceptance(),
    ...options,
  })
}

export function useGetActiveTermsOfServiceVersion(
  options?: Omit<
    UseQueryOptions<
      GetActiveTermsOfServiceVersionResponse,
      Error,
      GetActiveTermsOfServiceVersionResponse
    >,
    'queryKey' | 'queryFn'
  >,
) {
  const residentService = useResidentService()

  return useQuery<
    GetActiveTermsOfServiceVersionResponse,
    Error,
    GetActiveTermsOfServiceVersionResponse
  >({
    queryKey: [QueryKeys.getActiveTermsOfServiceVersion],
    queryFn: () => residentService.getActiveTermsOfServiceVersion(),
    ...options,
  })
}

export function useGetActivePrivacyPolicyVersion(
  options?: Omit<
    UseQueryOptions<
      GetActivePrivacyPolicyVersionResponse,
      Error,
      GetActivePrivacyPolicyVersionResponse
    >,
    'queryKey' | 'queryFn'
  >,
) {
  const residentService = useResidentService()

  return useQuery<
    GetActivePrivacyPolicyVersionResponse,
    Error,
    GetActivePrivacyPolicyVersionResponse
  >({
    queryKey: [QueryKeys.getActivePrivacyPolicyVersion],
    queryFn: () => residentService.getActivePrivacyPolicyVersion(),
    ...options,
  })
}

export function useGetAddressByPersonId(
  options?: Omit<
    UseQueryOptions<Address | null, Error, Address | null>,
    'queryKey' | 'queryFn'
  >,
) {
  const residentService = useResidentService()

  return useQuery<Address | null, Error, Address | null>({
    queryKey: [QueryKeys.getAddress],
    queryFn: () => residentService.getAddressByPersonId(),
    ...options,
  })
}
